!function($) {
    $(function() {
        $('form[id^=fruwo-form-]').on('submit', function (event) {
            event.preventDefault();
            var $form = $(this);
            var $form_response = $('#' + $form.attr('name') + '-response');
            var formData = $form.serializeArray();
            formData.push({
                name: 'action',
                value: AJAX.actions.fruwo_form,
            });
            $.post(
                AJAX.url,
                formData,
                function (response) {
                    if (response.success) {
                        $form_response.html('<div class="my-3 p-3 bg-success">' + response.data.message + '</div>');
                    } else {
                        $form_response.html('<div class="my-3 p-3 bg-danger">' + response.data.error + '</div>');
                    }
                    anchor_scroll('#' + $form_response.attr('id'));
                },
                'json'
            );
        });
    })
}(jQuery);
